'use strict'
var mapper = require('./mapper')
var compileRoute = require('./compileRoute')

module.exports = function urlMapper (options) {
  return mapper(compileRoute, options)
}



//////////////////
// WEBPACK FOOTER
// ./~/url-mapper/index.js
// module id = 283
// module chunks = 0